module.exports = __webpack_public_path__ + "images/_/programs/epsHybridPrimaries/images/characters/sara_twist_hands_out_heyhey-88fc7fcb491ac0a78f3ce4e8d416ce57.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridPrimaries/images/characters/sara_twist_hands_out_heyhey.png
// module id = 868
// module chunks = 2